export const STRIPE_PUBLIC_KEY
  = import.meta.env.VITE_VERCEL_ENV === 'production'
    ? 'pk_live_51MQz8xBfUBvElDy9RpzeP5fDdyTYYDmdsNP4A82WSVLx1hFEkrs2vxYMR3ME82JInZ7LIDdIpYr9gB5MoOandOMq004RLifOps'
    : 'pk_test_51MQz8xBfUBvElDy9PiWir3M7CxjducX1V2xPZ35RQIPcdwXPZBaMffN7kdhqbtYo2PXT8FHW99nw7t5e1lYrzITM00RAKJWiSC'
